<template>
  <div>
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 col-start-1 laptop:col-span-5 laptop:col-start-2">
            <BreadCrumbs
              class="text-lg uppercase leading-[1.2] tracking-[0.08em] text-ng70 laptop:text-xl laptop:leading-[1.7]"
            />
            <h1 class="flex items-center text-lg leading-[1.4] laptop:text-[32px]">
              <span class="flex capitalize">{{ $t("packaging") }}</span>
            </h1>
            <p class="subtitle">
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes?.hero_subtitle
              }}
            </p>
          </div>
          <div class="col-span-6 flex laptop:col-span-10 laptop:col-start-2">
            <img class="mt-12 laptop:mt-[56px]" src="/images/packages.jpg" alt="packages" />
          </div>
          <div
            class="col-span-6 mt-8 justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex"
          >
            <h3>
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes
                  ?.hero_packaging_options[0]?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes
                  ?.hero_packaging_options[1]?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes
                  ?.hero_packaging_options[2]?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes
                  ?.hero_packaging_options[3]?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypePackagingPageData?.productsProductTypePackagingPage?.data?.attributes
                  ?.hero_packaging_options[4]?.title
              }}
            </h3>
          </div>
          <!--          <div
            class="col-span-6 mt-8 flex flex-col items-center justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex-row"
          >
            <NextBtn class="col-span-6 laptop:col-span-3" :text="$t('learn-more-about-packaging-options')" />
          </div>-->
        </div>
      </SectionSet>
      <!--      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-6 laptop:col-span-10 laptop:col-start-2">{{ $t("Available Containers") }}</h2>
          <div class="col-span-6 mt-8 justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-2">
            <div
              v-for="(p, index) in r.data.value.parents?.data"
              :key="index"
              class="grid grid-cols-6 laptop:grid-cols-10 gap-x-6 mt-[24px]"
            >
              <div
                class="col-span-6 laptop:col-span-2 text-ng800 uppercase font-[500] border-y-[3px] border-y-ng200 h-[43px] flex items-center"
              >
                {{ p.attributes.name }}
              </div>
              <div
                class="flex justify-evenly flex-1 col-span-6 laptop:col-span-8 items-center tablet:[&>*+*]:ml-[12px] mt-4 laptop:mt-0 flex-col tablet:flex-row"
              >
                <div
                  v-for="(c, index) in p.attributes.children.data"
                  :key="index"
                  class="text-ng800 flex-1 bg-ng200 text-center h-[36px] flex items-center justify-center w-full tablet:w-auto mt-2 tablet:mt-0"
                >
                  {{ c.attributes.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionSet>-->
      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-6 laptop:col-span-5 laptop:col-start-2">{{ $t("Available Containers for Olives") }}</h2>
          <div
            class="col-span-5 mt-[9px] mb-[19px] flex laptop:col-span-3 laptop:col-end-12 laptop:mb-0 laptop:mt-0 laptop:mt-12 laptop:justify-end desktop:mt-0"
          >
            <DownloadBtn
              class="max-w-fit laptop:self-end"
              v-if="olivesFile"
              :text="$t('OLIVE PACKAGING BROCHURE')"
              :href="olivesFile.attributes?.packaging_brochure?.data?.attributes?.url"
            />
          </div>
          <div class="col-span-6 mt-8 justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-2">
            <div
              v-for="(p, index) in oliveContainers"
              :key="index"
              class="grid grid-cols-6 laptop:grid-cols-10 gap-x-6 mt-[24px]"
            >
              <div
                class="col-span-6 laptop:col-span-2 text-ng800 uppercase font-[500] border-y-[3px] border-y-ng200 h-[43px] flex items-center"
              >
                {{ $t(p.name) }}
              </div>
              <div
                class="flex justify-evenly flex-1 col-span-6 laptop:col-span-8 items-center tablet:[&>*+*]:ml-[12px] mt-4 laptop:mt-0 flex-col tablet:flex-row"
              >
                <div
                  v-for="(c, index) in p.children"
                  :key="index"
                  class="text-ng800 flex-1 bg-ng200 text-center h-[36px] flex items-center justify-center w-full tablet:w-auto mt-2 tablet:mt-0"
                >
                  {{ c }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionSet>

      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 flex laptop:col-span-10 laptop:col-start-2">
            <img src="/images/packages_fruits.jpg" alt="packages" />
          </div>
        </div>
      </SectionSet>
      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-6 laptop:col-span-5 laptop:col-start-2">{{ $t("Available Containers for Fruits") }}</h2>
          <div
            class="col-span-5 mt-[9px] mb-[19px] flex laptop:col-span-3 laptop:col-end-12 laptop:mb-0 laptop:mt-0 laptop:mt-12 laptop:justify-end desktop:mt-0"
          >
            <DownloadBtn
              class="max-w-fit laptop:self-end"
              v-if="fruitsFile"
              :text="$t('FRUIT PACKAGING BROCHURE')"
              :href="fruitsFile.attributes?.packaging_brochure?.data?.attributes?.url"
            />
          </div>
          <div class="col-span-6 mt-8 justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-2">
            <div
              v-for="(p, index) in fruitContainers"
              :key="index"
              class="grid grid-cols-6 laptop:grid-cols-10 gap-x-6 mt-[24px]"
            >
              <div
                class="col-span-6 laptop:col-span-2 text-ng800 uppercase font-[500] border-y-[3px] border-y-ng200 h-[43px] flex items-center"
              >
                {{ $t(p.name) }}
              </div>
              <div
                class="flex justify-evenly flex-1 col-span-6 laptop:col-span-8 items-center tablet:[&>*+*]:ml-[12px] mt-4 laptop:mt-0 flex-col tablet:flex-row"
              >
                <div
                  v-for="(c, index) in p.children"
                  :key="index"
                  class="text-ng800 flex-1 bg-ng200 text-center h-[36px] flex items-center justify-center w-full tablet:w-auto mt-2 tablet:mt-0"
                >
                  {{ c }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
    <!--    <SectionSet>
      <div class="flex flex-col">
        <CustomizationSection class="w-full" />
      </div>
    </SectionSet>-->
    <GridWrapper>
      <SectionSet isLast>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 col-start-1 laptop:col-span-10 laptop:col-start-2">
            <SliderBrands
              :products="productProductTypePackagingPageData?.products?.data"
              :title="$t('take-a-look-at-our-pre-packaged-products')"
              :buttonText="$t('take-a-look-at-brands')"
            />
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
  </div>
</template>
<script setup lang="ts">
const { locale, finalizePendingLocaleChange } = useI18n();

await finalizePendingLocaleChange();

const { data: productProductTypePackagingPageData } = await useAsyncGql({
  operation: "ProductsProductTypePackagingPage",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

const r = await useAsyncGql({
  operation: "ProductSizes",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

const oliveContainers = ref([
  {
    name: "GLASS CONTAINERS",
    children: ["212ml", "282ml", "314ml", "370ml", "395ml", "500ml", "720ml", "1000ml", "1062ml", "1700ml", "2000ml"],
  },
  {
    name: "ΤIN CONTAINERS",
    children: ["425ml", "850ml", "Α10", "A12", "8l", "20l"],
  },
  {
    name: "PLASTIC PACKAGING",
    children: ["1.5l", "2l", "2.4l", "3l", "3.3l", "5l", "8l", "20l", "80l", "190l", "220l"],
  },
  {
    name: "PILLOWBAG",
    children: ["30g", "60g", "100g"],
  },
  {
    name: "VACUUM BAGS",
    children: ["150g", "1kg", "5kg"],
  },
]);

const fruitContainers = ref([
  {
    name: "GLASS CONTAINERS",
    children: ["370ml", "420ml", "580ml", "720ml"],
  },
  {
    name: "METAL CANS",
    children: ["850ml", "2650ml", "3150ml", "4250ml"],
  },
  {
    name: "ASEPTIC BAGS",
    children: ["Carton Drums (160 kg)", "Metal Drums (200kg)", "1-ton Carton Box"],
  },
]);

const files = computed(() => {
  return (
    r.data.value?.productTypes?.data.filter((p) => {
      return !!p.attributes?.packaging_brochure?.data;
    }) || []
  ); //.filter((p) => p.attributes.slug === "packaging")[0]?.attributes?.files?.data;
});

const olivesFile = computed(() => {
  return files.value.find((f) => f.attributes.slug === "olives" || f.attributes.slug === "elies");
});

const fruitsFile = computed(() => {
  return files.value.find((f) => f.attributes.slug === "fruits" || f.attributes.slug === "froyta");
});
</script>
